// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const denyAuthorizationQueryParamsSchema = z.object({
  client_id: z.optional(z.coerce.string().describe("OAuth 2.0 client identifier")),
  redirect_uri: z.optional(z.coerce.string().describe("OAuth 2.0 redirect URI")),
  response_type: z.optional(z.coerce.string().describe("OAuth 2.0 response type")),
}).optional();

/**
 * @description redirect with access denied error
 */
export const denyAuthorization302Schema = z.unknown();
